import {
  accreditationTypes,
  CheckboxGroup,
  individualInvestorQualifications,
  institutionalInvestorQualifications,
  otherEntitiesInstitutionsQualification,
  noneOfTheAboveQualification,
  RadioButtonGroup,
  DropDownMenu,
  required,
  selectOptions,
  withAlertHandler,
  TextField,
  benefitQuestions,
  qualifiedPurchaser,
  benefitQuestionsOptionThree,
  selectedQualifiePurchaserQuestion,
  setUserAction,
} from 'entoro-shared';
import { withApollo } from 'react-apollo';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FaQuestionCircle } from 'react-icons/fa';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { updateSelectedOptionTypes } from '../../../apollo';

const qualificationOptions = {
  INDIVIDUAL: individualInvestorQualifications.options,
  INSTITUTION: institutionalInvestorQualifications.options,
  OTHER_ENTITIES: otherEntitiesInstitutionsQualification.options,
  NONE_OF_THE_ABOVE: noneOfTheAboveQualification.options,
};

const accreditationObj = {
  YES: accreditationTypes.options.filter((val, index) => {
    return index < 4;
  }),
  // I_DONT_KNOW: accreditationTypes.options.filter((val, index) => {
  //   return index == 2;
  // }),
};

const InvestorQualificationForm = reduxForm({
  form: 'investorQualification',
  enableReinitialize: true,
})((props) => {
  const {
    dispatch,
    handleSubmit,
    submitting,
    update,
    selectedAccreditationType,
    qualificationType,
    selectedOptionType,
    selectedIntendedFundType,
    selectedBenefitInvestorType,
    selectedQualifiedInvestorType,
    selectedBenefitInvestorQuestionType,
    change,
    initialValues,
    setSnackbarMessage,
    history,
    handleSnackbarError,
    client,
  } = props;

  props.initialValues.accreditationType =
    props.initialValues.accreditationType == null
      ? 'INDIVIDUAL'
      : props.initialValues.accreditationType;

  const onlyNumber = (value) => {
    const onlyNums = value.replace(/[^\d]/g, '');
    return onlyNums;
  };

  const showAccrType = () => {
    if (selectedOptionType == 'YES') {
      return (
        <Field
          className='checkbox-field w-checkbox'
          component={RadioButtonGroup}
          validate={[required]}
          name='accreditationType'
          label='Accreditation Type'
          options={
            selectedOptionType == null
              ? accreditationTypes.options
              : accreditationObj[selectedOptionType]
          }
          required
          normalize={(value) => {
            if (value === initialValues.accreditationType) {
              change('qualifications', initialValues.qualifications);
            } else {
              change('qualifications', []);
            }
            return value;
          }}
        />
      );
    } else {
      return null;
    }
  };

  const showQualOp = () => {
    if (
      selectedOptionType == 'YES' &&
      (selectedAccreditationType == 'INDIVIDUAL' ||
        selectedAccreditationType == 'INSTITUTION' ||
        selectedAccreditationType == 'OTHER_ENTITIES' ||
        selectedAccreditationType == 'NONE_OF_THE_ABOVE')
    ) {
      return (
        <div className='qualification-col2 w-col w-col-5'>
          {selectedAccreditationType == 'NONE_OF_THE_ABOVE' ? (
            <Field
              // normalize={onlyNumber}
              validate={[required]}
              label='Please describe how you otherwise qualify as an Accredited Investor.'
              component={TextField}
              name='nonOtherAccreditionText'
              required
              // pattern='[0-9]*'
            />
          ) : (
            <Field
              label='Please select all that apply'
              component={CheckboxGroup}
              name='qualifications'
              validate={[required]}
              options={qualificationOptions[selectedAccreditationType]}
              required
            />
          )}

          {qualificationType.includes('CENTERAL_REGISTRATION_NUMBER') && (
            <a href='https://www.investor.gov/introduction-investing/investing-basics/glossary/central-registration-depository-crd'>
              Click to read more
            </a>
          )}

          {qualificationType.includes('CENTERAL_REGISTRATION_NUMBER') && (
            <Field
              normalize={onlyNumber}
              validate={[required]}
              required={qualificationType.includes(
                'CENTERAL_REGISTRATION_NUMBER'
              )}
              label='Enter Your Central Registration Number'
              component={TextField}
              name='centeralRegistrationNumber'
              pattern='[0-9]*'
            />
          )}

          {qualificationType.includes('INDIVIDUAL_OTHER') && (
            <Field
              // normalize={onlyNumber}
              required={qualificationType.includes(
                'CENTERAL_REGISTRATION_NUMBER'
              )}
              validate={[required]}
              label='Please describe how you otherwise qualify as an Individual Accredited Investor.'
              component={TextField}
              name='individualOther'
              // pattern='[0-9]*'
            />
          )}
          {qualificationType.includes('INSTITUTIONAL_OTHER') && (
            <Field
              // normalize={onlyNumber}
              required={qualificationType.includes(
                'CENTERAL_REGISTRATION_NUMBER'
              )}
              validate={[required]}
              label='Please describe how you otherwise qualify as an Institutional Accredited Investor'
              component={TextField}
              name='institutionalOther'
              // pattern='[0-9]*'
            />
          )}
        </div>
      );
    } else {
      return null;
    }
  };

  const changeSelOption = async (e) => {
    let data = e.target.value;

    if (data == 'YES') {
    } else if (data == 'NO') {
      // const { mutate } = client;
      // try {
      //   const variables = {
      //     selectedOptionTypes: 'NO',
      //     intendInvestingFunds: 'NO',
      //   };
      //   const { data } = await mutate({
      //     mutation: updateSelectedOptionTypes,
      //     variables,
      //   });
      //   dispatch(setUserAction(data));
      //   setSnackbarMessage('Account updated successfully');
      //   history.push('/account/suitability');
      // } catch (error) {
      //   handleSnackbarError(error);
      // }
    }
  };

  const showFundBenefitOptions = () => {
    if (selectedBenefitInvestorType == 'YES') {
      return (
        <Field
          className='checkbox-field w-checkbox'
          component={RadioButtonGroup}
          validate={[required]}
          name='benefitInvestorQuestions'
          label='Please select the statement that applies'
          options={benefitQuestions.options}
          required
          // normalize={(value) => {
          //   if (value === initialValues.accreditationType) {
          //     change('benefitInvestorQuestions', initialValues.benefitInvestorQuestions);
          //   } else {
          //     change('benefitInvestorQuestions', []);
          //   }
          //   return value;
          // }}
        />
      );
    } else {
      return null;
    }
  };

  const showFundQualifiedPurchaserOption = () => {
    if (selectedQualifiedInvestorType == 'YES') {
      return (
        <Field
          className='checkbox-field w-checkbox'
          component={RadioButtonGroup}
          validate={[required]}
          name='qualifiedPurchaserQuestion'
          label='Please select the statement that applies'
          options={qualifiedPurchaser.options}
          required
        />
      );
    } else {
      return null;
    }
  };

  const showFundBenefitOptionsThree = () => {
    if (selectedBenefitInvestorQuestionType == 'OPTION_THREE') {
      return (
        <Field
          className='checkbox-field w-checkbox'
          component={RadioButtonGroup}
          validate={[required]}
          name='benefitInvestorQuestionsOther'
          label='Please select the statement that applies'
          options={benefitQuestionsOptionThree.options}
          required
        />
      );
    } else {
      return null;
    }
  };

  // const showFundQualOp = () => {
  //   if (
  //     selectedOptionType == 'YES' &&
  //     (selectedAccreditationType == 'INDIVIDUAL' ||
  //       selectedAccreditationType == 'INSTITUTION' ||
  //       selectedAccreditationType == 'OTHER_ENTITIES' ||
  //       selectedAccreditationType == 'NONE_OF_THE_ABOVE')
  //   ) {
  //     return (
  //       <div className='qualification-col2 w-col w-col-5'>
  //         <Field
  //           label='Please select all that apply'
  //           component={CheckboxGroup}
  //           name='qualifications'
  //           options={qualificationOptions[selectedAccreditationType]}
  //         />
  //         {qualificationType.includes('CENTERAL_REGISTRATION_NUMBER') && (
  //           <a href='https://www.investor.gov/introduction-investing/investing-basics/glossary/central-registration-depository-crd'>
  //             Click to read more
  //           </a>
  //         )}

  //         {qualificationType.includes('CENTERAL_REGISTRATION_NUMBER') && (
  //           <Field
  //             normalize={onlyNumber}
  //             required={qualificationType.includes(
  //               'CENTERAL_REGISTRATION_NUMBER'
  //             )}
  //             label='Enter Your Central Registration Number'
  //             component={TextField}
  //             name='centeralRegistrationNumber'
  //             pattern='[0-9]*'
  //           />
  //         )}

  //         {qualificationType.includes('INDIVIDUAL_OTHER') && (
  //           <Field
  //             // normalize={onlyNumber}
  //             required={qualificationType.includes(
  //               'CENTERAL_REGISTRATION_NUMBER'
  //             )}
  //             label='Please describe how you otherwise qualify as an Individual Accredited Investor.'
  //             component={TextField}
  //             name='individualOther'
  //             // pattern='[0-9]*'
  //           />
  //         )}
  //         {qualificationType.includes('INSTITUTIONAL_OTHER') && (
  //           <Field
  //             // normalize={onlyNumber}
  //             required={qualificationType.includes(
  //               'CENTERAL_REGISTRATION_NUMBER'
  //             )}
  //             label='Please describe how you otherwise qualify as an Institutional Accredited Investor'
  //             component={TextField}
  //             name='institutionalOther'
  //             // pattern='[0-9]*'
  //           />
  //         )}
  //       </div>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  const changeFundSelOption = async (e) => {
    let data = e.target.value;

    if (data == 'YES') {
    } else if (data == 'NO') {
    }
  };

  // const changeFundSelIntendedOption = async (e) => {
  //   let data = e.target.value;

  //   if (data == 'YES') {
  //   } else if (data == 'NO') {
  //     const { mutate } = client;
  //     try {
  //       const variables = {
  //         intendInvestingFunds: 'NO',
  //       };

  //       const { data } = await mutate({
  //         mutation: updateSelectedOptionTypes,
  //         variables,
  //       });

  //       dispatch(setUserAction(data));
  //       setSnackbarMessage('Account updated successfully');
  //       history.push('/account/suitability');
  //     } catch (error) {
  //       handleSnackbarError(error);
  //     }
  //   }
  // };

  const changeFundSelBenefitOption = async (e) => {
    let data = e.target.value;

    if (data == 'YES') {
    } else if (data == 'NO') {
    }
  };

  return (
    <div className='w-clearfix w-form'>
      <form onSubmit={handleSubmit(update)}>
        <div className='column-fields w-row'>
          <div className='form-fields-container'>
            <Field
              component={DropDownMenu}
              validate={[required]}
              name='selectedOptionTypes'
              onChange={changeSelOption}
              label='I am an Accredited Investor?'
              options={selectOptions.options}
              required
            />
          </div>
        </div>
        <div className='column-fields w-row'>
          <div className='w-col w-col-4'>{showAccrType()}</div>
          {showQualOp()}
        </div>
        <div className='w-col w-col-3' />
        <div className='full-line' />
        <div className='column-fields w-row'>
          <div className='form-fields-container'>
            <Field
              component={DropDownMenu}
              validate={[required]}
              name='intendInvestingFunds'
              // onChange={changeFundSelIntendedOption}
              label='Do you intend to invest in Funds?'
              options={selectOptions.options}
            />
          </div>
        </div>

        {selectedIntendedFundType == 'YES' && (
          <React.Fragment>
            <div className='column-fields w-row'>
              <div className='form-fields-container'>
                <p style={{ color: '#757575', display: 'flex' }}>
                  Are you a Qualified Purchaser under the Investment Company Act
                  of 1940.{' '}
                  <div
                    data-tip='“Qualified purchaser” means—<br/> 
                    (i) any natural person who owns not less than<br/> 
                    $5,000,000 in investments, as defined by the Commission;<br/> 
                    (ii) any company that owns not less than $5,000,000 in investments;<br/> 
                    (iii) any trust that is not covered by clause (ii); or (iv) any person,<br/>  
                    acting for its own account or the accounts of other qualified purchasers,<br/>  
                    who in the aggregate owns and invests on a discretionary basis,<br/>  
                    not less than $25,000,000 in investments.'
                    data-for='toolTip1'
                    data-place='right'
                  >
                    <FaQuestionCircle />
                  </div>
                  <ReactTooltip id='toolTip1' multiline={true} />
                </p>
                <Field
                  component={DropDownMenu}
                  validate={[required]}
                  name='qualifiedPurchaser'
                  onChange={changeFundSelOption}
                  // label={`Are you a Qualified Purchaser under the Investment Company Act of 1940?`}
                  options={selectOptions.options}
                  required
                />
              </div>
            </div>
          </React.Fragment>
        )}
        <div className='column-fields w-row'>
          <div className='w-col w-col-12'>
            {showFundQualifiedPurchaserOption()}
          </div>
        </div>

        {selectedIntendedFundType == 'YES' && (
          <React.Fragment>
            <div className='column-fields w-row'>
              <div className='form-fields-container'>
                <p style={{ color: '#757575', display: 'flex' }}>
                  Are you a Benefit Plan Investor.{' '}
                  <div
                    data-tip='“Benefit Plan Investor” means—<br/> 
                    (i) an employee benefit plan (as such term is defined in<br/>  
                    Section 3(3) of ERISA) whether or not subject to the provisions<br/> 
                     of Title I of ERISA,(ii) a plan described in Section 4975(e)<br/> 
                    (1) of the Code or (iii) any entity whose underlying assets include<br/>  
                    assets of a plan described in (i) or (ii) by reason of such plan’s<br/>  
                    investment in the entity.'
                    data-for='toolTip1'
                    data-place='right'
                  >
                    <FaQuestionCircle />
                  </div>
                  <ReactTooltip id='toolTip1' multiline={true} />
                </p>
                <Field
                  component={DropDownMenu}
                  validate={[required]}
                  name='benefitInvestor'
                  onChange={changeFundSelBenefitOption}
                  // label='Are you a Benefit Plan Investor?'
                  options={selectOptions.options}
                  required
                />
              </div>
            </div>
          </React.Fragment>
        )}

        <div className='column-fields w-row'>
          <div className='w-col w-col-4'>{showFundBenefitOptions()}</div>
          <div className='w-col w-col-4'>{showFundBenefitOptionsThree()}</div>
          {/* {showFundQualOp()} */}
        </div>

        <div>
          {selectedQualifiePurchaserQuestion == 'OPTION_SIX' && (
            <div className='column-fields w-row'>
              <div className='w-col w-col-12'>
                <Field
                  label='Please describe how you otherwise qualify as a Qualified Purchaser'
                  component={TextField}
                  name='benefitInvestorQuestionsOther'
                  validate={[required]}
                  required
                />
              </div>
            </div>
          )}
        </div>

        <div className='w-col w-col-3' />
        <div className='full-line' />

        <input
          type='submit'
          value='Save & Continue'
          disabled={submitting}
          className={`button-2 w-button ${submitting ? 'btn-disabled' : ':'}`}
        />
      </form>
    </div>
  );
});

const mapStateToProps = (state) => {
  const selector = formValueSelector('investorQualification');
  return {
    qualificationType: selector(state, 'qualifications'),
    selectedAccreditationType:
      selector(state, 'accreditationType') || 'INDIVIDUAL',
    selectedOptionType: selector(state, 'selectedOptionTypes'),
    selectedIntendedFundType: selector(state, 'intendInvestingFunds'),
    selectedBenefitInvestorType: selector(state, 'benefitInvestor'),
    selectedQualifiedInvestorType: selector(state, 'qualifiedPurchaser'),
    selectedQualifiePurchaserQuestion: selector(
      state,
      'qualifiedPurchaserQuestion'
    ),
    selectedBenefitInvestorQuestionType: selector(
      state,
      'benefitInvestorQuestions'
    ),
    initialValues: state.investorUser,
    initialQualificationValues: state.accredited,
  };
};

export default connect(mapStateToProps)(
  withApollo(withRouter(withAlertHandler(InvestorQualificationForm)))
);



// WEBPACK FOOTER //
// ./src/components/Account/InvestorQualification/InvestorQualificationForm.js